// import React from 'react'

// function Coupon() {
//   return (
//     <>
//     <div className='container-fluid '>
//      <div className='container bg-light text-light'>
//         <h1 className='text-center text-dark'>Coupons</h1>
//         <div className='row justify-content-center align-items-center'>
//             <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 '>
//                <div className='text-light  w-75 bg-col'>
//                     <h1>New Year</h1>
//                     <h4>25% offer</h4>
//                </div>
//             </div>
//             <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 '>
//                 <div className='text-light  w-75 bg-col'>
//                     <h1>New Year</h1>
//                     <h4>25% offer</h4>
//                </div>
//             </div>
//             <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 '>
//                 <div className='text-light  w-75 bg-col'>
//                     <h1>New Year</h1>
//                     <h4>25% offer</h4>
//                </div>
//             </div>
//         </div>
//         <div className='row justify-content-center align-items-center'>
//             <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 '>
//                <div className='text-light  w-75 bg-col'>
//                     <h1>New Year</h1>
//                     <h4>25% offer</h4>
//                </div>
//             </div>
//             <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 '>
//                 <div className='text-light   w-75 bg-col'>
//                     <h1>New Year</h1>
//                     <h4>25% offer</h4>
//                </div>
//             </div>
//             <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 '>
//                 <div className='text-light  w-75 bg-col'>
//                     <h1>New Year</h1>
//                     <h4>25% offer</h4>
//                </div>
//             </div>
//         </div>
//      </div>
//      </div>
//     </>
//   )
// }

// export default Coupon



// import React, { useEffect, useState } from "react";
// import axios from "axios";

// function Coupon() {
//   const [coupons, setCoupons] = useState([]);

//   useEffect(() => {
//     fetchCoupons();
//   }, []);

//   const fetchCoupons = async () => {
//     try {
//       const res = await axios.get(
//         "https://ecom.cyberathon.com/index.php/Api/list_coupon"
//       );
//       setCoupons(res.data.data || []);
//     } catch (error) {
//       console.error("Coupon API Error:", error);
//     }
//   };

//   return (
//     <div className="container-fluid bg-light py-5">
//       <div className="container">
//         <h2 className="text-center mb-4 fw-bold">Available Coupons</h2>

//         <div className="row justify-content-center">
//           {coupons
//           .filter(coupon => coupon.status === "active")   // 👈 ONLY ACTIVE
//           .map((coupon) => (
//             <div
//               key={coupon.coupon_id}
//               className="col-12 col-sm-6 col-md-4 mb-4"
//             >
//               <div className="card shadow-sm h-100 border-0">
//                 <div className="card-body text-center">

//                   {/* STATUS */}
//                   {/* <span
//                     className={`badge mb-2 ${
//                       coupon.status === "active"
//                         ? "bg-success"
//                         : "bg-secondary"
//                     }`}
//                   >
//                     {coupon.status}
//                   </span> */}

//                   {/* NAME */}
//                   <h5 className="card-title mt-2">
//                     {coupon.coupon_name}
//                   </h5>

//                   {/* DISCOUNT */}
//                   <p className="text-primary ">
//                     {/* {coupon.discount_value}% OFF */}
//                     {coupon.discount_value}% OFF on orders above ₹{coupon.min_order_value}
//                   </p>
// <div className="d-flex justify-content-center align-items-center gap-4">
//                   {/* CODE */}
//                   <button className="bg-light border-0 px-1 py-2 rounded-1 text-dark  fw-semibold">
//                     Code: {coupon.code}
//                   </button>
                  
//                   {/* <button className="bg-col border-0 px-1 py-2 rounded-1 text-light">
//                     Apply Coupon
//                   </button> */}
// </div>
//                   {/* INFO */}
//                   {/* <p className="text-muted small mb-1">
//                     Min Order ₹{coupon.min_order_value}
//                   </p>
//                   <p className="text-muted small">
//                     Max Discount ₹{coupon.max_discount}
//                   </p> */}

//                   {/* DATE */}
//                   {/* <p className="text-muted small">
//                     <i className="bi bi-calendar-event me-1"></i>
//                     {coupon.start_date} - {coupon.end_date}
//                   </p> */}

//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//       </div>
//     </div>
//   );
// }

// export default Coupon;



import React, { useEffect, useState } from "react";
import axios from "axios";
import Layout from "../../Layout/Layout";
import FooterNew from "../../Layout/FooterNew";
import SEO from "../../SEO";

const BASE_URL = "https://ecom.cyberathon.com/index.php/Api";
function Coupon() {
  const [coupons, setCoupons] = useState([]);
 const [seoData, setSeoData] = useState({});

   useEffect(() => {
    const fetchSeo = async () => {
      try {
        const response = await axios.post(`${BASE_URL}/get_seo_by_page`, { page_name: 'coupon' });

        if (response.data.status === 'true') {
          const data = response.data.data;
          setSeoData({
            title: data.meta_title,
            description: data.meta_description,
            keywords: data.meta_keywords,
            canonical: data.canonical_url,
          });
        }
      } catch (error) {
        console.error('SEO fetch error:', error);
      }
    };

    fetchSeo();
  }, []);

  useEffect(() => {
    fetchCoupons();
  }, []);

  const fetchCoupons = async () => {
    try {
      const res = await axios.get(
        "https://ecom.cyberathon.com/index.php/Api/list_coupon"
      );
      setCoupons(res.data.data || []);
    } catch (error) {
      console.error("Coupon API Error:", error);
    }
  };
const today = new Date();
today.setHours(0, 0, 0, 0);

const isValidCoupon = (coupon) => {
  const endDate = new Date(coupon.end_date);
  endDate.setHours(0, 0, 0, 0);

  return coupon.status === "active" && endDate >= today;
};

  return (
    <>
    <SEO
      title={seoData.title || "best cupping therapy tools ,authentic cupping supplies | shopeindia"}
      description={seoData.description || "ShopIndia is the best online shopping platform..."}
      keywords={seoData.keywords || "ShopIndia, online shopping, electronics, clothes, medicines"}
      canonical={seoData.canonical || "https://www.shopindia.com/"}
    />
    <Layout/>
    <div className="container-fluid coupon-wrap py-5">
      <div className="container">

      
        <h2 className="coupon-heading text-center mb-5">
          Available Coupons
        </h2>

        <div className="row">
          {coupons
            // .filter((coupon) => coupon.status === "active")
            .filter(isValidCoupon)
            .map((coupon) => (
              <div
                key={coupon.coupon_id}
                className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
              >
                <div className="coupon-card-new">

                 
                  <h5 className="coupon-title">
                    {coupon.coupon_name}
                  </h5>

                  
                  <div className="coupon-discount">
                    {coupon.discount_value}% OFF
                  </div>

                
                  <p className="coupon-min">
                    On orders above ₹{coupon.min_order_value}
                  </p>

                 
                  <div className="coupon-code">
                    {coupon.code}
                  </div>

                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
    <FooterNew/>
    </>
  );
}

export default Coupon;
